import React from "react";

const NetContent = ({ value }) => {
  return value?.map((element) => {
    return <tr>{`${element["net_content"]} ${element["unit_of_measure"]}`} </tr>;
  });
};

export default NetContent;
